/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { equalScalarDependencies } from './dependenciesEqualScalar.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { roundDependencies } from './dependenciesRound.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createCeil } from '../../factoriesAny.js';
export var ceilDependencies = {
  equalScalarDependencies,
  matrixDependencies,
  roundDependencies,
  typedDependencies,
  createCeil
};